import { defineMessages } from 'react-intl';

export const wizardRatesPanelMessages = defineMessages({
  title: {
    defaultMessage: 'Rates',
    id: 'tnQeKK',
    description: 'Title for the wizard rates panel',
  },
  noRates: {
    defaultMessage: 'No rates available yet. Complete the steps to see rates.',
    id: 'Vja7rK',
    description: 'Empty state message when no freight rates are loaded in the wizard',
  },
  refreshAriaLabel: {
    defaultMessage: 'Refresh rates',
    id: 'ePii7q',
    description: 'Aria label for the refresh rates icon button',
  },
  viewMoreRates: {
    defaultMessage: 'View More Rates ({count})',
    id: 'BU2EVu',
    description: 'Ghost button to reveal additional freight rates',
  },
  poweredBy: {
    defaultMessage: 'Rates powered by WWEX / SpeedShip',
    id: 'kn5Dzy',
    description: 'Footer attribution for the freight rates provider',
  },
});
